import React, {Component} from 'react';
import CustomAppBar from "./../shared/utils/CustomAppBar";
import AuthService from "../../services/AuthService";
import Alert from "../shared/utils/Alert";
import moment from './../shared/utils/moment_fr';


export default class AdminIndex extends Component {

    constructor(props) {
        super(props);
        this.state = {entreprises: [], changes: {}};
        this.auth = new AuthService();
        this.fetchSocietes = this.fetchSocietes.bind(this);
        this.editMaxSalaries = this.editMaxSalaries.bind(this);


    }

    componentDidMount() {
        this.fetchSocietes();
    }

    fetchSocietes() {
        this.auth.fetch('/admin/societes')
            .then(x => this.setState({entreprises: x.data.payload}));
    }

    editMaxSalaries(id_societe, initial_max_salaries) {
        let max_salaries = this.state.changes[id_societe];
        if (!max_salaries) {
            max_salaries = initial_max_salaries;
        }
        this.auth.fetch('/admin/societe/max_salaries', {
            method: 'POST',
            data: {id_societe: id_societe, max_salaries: max_salaries}
        })
            .then(x => {
                this.fetchSocietes();
                window.alert('Modification avec succès');
            });
    }

    render() {
        return (
            <div className="entreprise-container">
                <CustomAppBar
                    disableLeftClick={true}
                    titlePath='/admin'
                    history={this.props.history}
                    title='Administration'/>

                <div className="container-fluid">
                    <br/>
                    <Alert text="Ci-dessous la liste de toutes les entreprises inscrites sur monEntretienPRO"/>
                    <table className="table table-striped">
                        <thead className="thead-dark">
                        <tr>
                            <th scope="col">N°</th>
                            <th scope="col">Société</th>
                            <th scope="col">Coordonnées</th>
                            <th scope="col">Adresse</th>
                            <th scope="col">Date d'inscription</th>
                            <th scope="col">Forfait Salariés</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.entreprises.map((e, i) =>
                                <tr key={e.id}>
                                    <th scope="row">{i + 1}</th>
                                    <td>{e.nom}<br/>Siret: {e.siret}</td>
                                    <td>Tel: {e.tel}<br/>Email: {e.email}</td>
                                    <td>{e.adresse}<br/>{e.ville}, {e.cp}</td>
                                    <td>{moment(e.date_inscription).format('DD/MM/YYYY HH:mm')}</td>
                                    <td>
                                        <input
                                            type="number"
                                            min="1"
                                            defaultValue={e.max_salaries}
                                            onChange={v => {
                                                let obj = this.state.changes;
                                                obj[e.id] = v.target.value;
                                                this.setState({
                                                    changes: obj

                                                });
                                            }}/>
                                        <button
                                            className="btn btn-sm btn-info"
                                            onClick={() => this.editMaxSalaries(e.id, e.max_salaries)}>Changer
                                        </button>
                                    </td>

                                </tr>
                            )
                        }

                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/admin/index.js